import { formatTimeSpan } from '@zapier/date';
import { Colors, Icon, Link, Typography } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import UsageBar from './UsageBar';
const Styles = labelStyles('UniversalSidebarUsage', {
    root: {
        display: 'grid',
        gap: 10,
        whiteSpace: 'nowrap',
        padding: '0 10px 10px',
    },
    header: Object.assign(Object.assign({ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: 20, alignItems: 'center' }, Typography.base), { fontSize: 16, fontWeight: 600, color: Colors.gray80 }),
    planName: Object.assign(Object.assign({ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }, Typography.paragraph3Medium), { color: Colors.neutral700 }),
    content: {
        margin: '0 5px',
    },
    usages: {
        display: 'grid',
        gap: 5,
        marginBottom: 5,
    },
    resetInfo: Object.assign(Object.assign({ display: 'grid', gap: 10 }, Typography.smallPrint1Medium), { gridTemplateRows: '1fr auto', paddingTop: '10px', color: Colors.neutral700 }),
    managePlanLink: {
        fontWeight: 600,
        textDecoration: 'underline',
        '&:hover, &:focus': {
            color: Colors.blue,
            outline: 'none',
        },
    },
});
const Usages = (props) => {
    const hasUsedExtraTasks = props.isPlanMetered && props.numTasks > props.numFreeTasksMax;
    return (isolateComponent("div", { css: Styles.usages },
        isolateComponent(UsageBar, { label: props.isPlanMetered ? 'Included Tasks' : 'Tasks', max: props.isPlanMetered ? props.numFreeTasksMax : props.numTasksMax, value: props.isPlanMetered
                ? Math.min(props.numTasks, props.numFreeTasksMax)
                : props.numTasks }),
        hasUsedExtraTasks && (isolateComponent(UsageBar, { label: "Extra Tasks", max: props.numTasksMax - props.numFreeTasksMax, value: props.numTasks - props.numFreeTasksMax })),
        isolateComponent(UsageBar, { label: "Zaps", max: props.numZapsMax, value: props.numZaps })));
};
const UniversalSidebarUsage = (props) => {
    const relativeDate = formatTimeSpan(Date.now(), props.resetDate, false);
    return (isolateComponent("section", { css: Styles.root },
        isolateComponent("div", { css: Styles.header },
            isolateComponent(Icon, { name: "miscWallet", size: 30 }),
            isolateComponent("h3", { css: Styles.planName }, props.title)),
        isolateComponent("div", { css: Styles.content },
            isolateComponent(Usages, Object.assign({}, props)),
            isolateComponent("p", { css: Styles.resetInfo },
                isolateComponent("span", null,
                    "Monthly usage resets in ",
                    relativeDate),
                isolateComponent(Link, { href: props.managePlanHref }, "Manage Plan"))),
        props.children));
};
UniversalSidebarUsage.defaultProps = {
    isPlanMetered: false,
    numFreeTasksMax: 0,
    managePlanHref: '/app/settings/billing',
    title: 'Usage',
};
export default UniversalSidebarUsage;
//# sourceMappingURL=UniversalSidebarUsage.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
